import template from './template.html?raw'

class TagsFilter extends HTMLElement {

  connectedCallback() {

    // layout
    this.innerHTML = template

    // pass down attributes to input
    const inputEl = this.input
    const wrapper = this.firstElementChild
    const attrs = Object.assign({}, this.attributes)
    for(const prop in attrs){
      const attr = attrs[prop]
      const name = attr.name
      const value = attr.value
      // actual submittable input should be hidden
      if(name != 'type'){
        // move options and label to wrapper x-data div, else goes on input
        const targetDiv = ['options', 'label'].includes(name) ? wrapper : inputEl
        targetDiv.setAttribute(name, value)
        this.removeAttribute(name)
      }
    }
  }

  get input(){
    return this.querySelector('input[type="hidden"]')
  }
}

export default function () {
  customElements.define('tags-filter', TagsFilter)
}